export const SLIDING_WINDOW_COLUMN_WIDTHS = {
  [0]: null,
  [1]: { xs: '12', sm: '12', md: '4', lg: '3' },
  [2]: { xs: '12', sm: '12', md: '8', lg: '6' },
  [3]: { xs: '12', sm: '12', md: '12', lg: '9' },
  [4]: { xs: '12', sm: '12', md: '12', lg: '12' },
} as const;
